module.exports = __webpack_public_path__ + "img/turn_left.a3a59403.svg";